import { render, staticRenderFns } from "./TokenFlow.vue?vue&type=template&id=440108e3&scoped=true"
import script from "./TokenFlow.vue?vue&type=script&lang=js"
export * from "./TokenFlow.vue?vue&type=script&lang=js"
import style0 from "./TokenFlow.vue?vue&type=style&index=0&id=440108e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440108e3",
  null
  
)

export default component.exports